import type { TextContent } from '@/core/types';

import { TextBlock } from '@/containers/blocks/text';

export default function generate({
  content,
  className,
}: {
  content: TextContent;
  className?: string;
}) {
  return (
    <TextBlock
      title={content.title}
      description={content.description}
      features={content.features}
      buttons={content.buttons}
      className={className}
    />
  );
}
